import React, { useState } from 'react';
import Axios from 'axios';
import { servicios_grupogack_org, registro_no_guardado } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import ModalService from './../../../ModalService/ModalService';
import FormTurnos from './FormTurnos'; 
import AlertForm from '../../../../../../Services/AlertForm';
import { JsonTurnosAdd } from '../../../Helpers/JsonToOneLevel';

const ModalAddTurnos = ({ openAdd, setOpenAdd, agregar, errorTable, nombreModulo }) => {
    
    const [ error, setError ] = useState( null );

    const cerrarModal = () => {
        setOpenAdd( false );
        setError( null );
    }

    const enviarTurnos = turno => {
        Axios.post(`${servicios_grupogack_org}/turno/`, turno, headersAuth())
        .then( respuesta => {
            switch( respuesta.data.status ){
                case 200:                    
                    agregar(JsonTurnosAdd(respuesta.data.dataResponse[0]));
                    setOpenAdd( false );
                    break;
                case 400:
                    setError( <AlertForm message={ respuesta.data.msg } /> );
                    break;
                default:
                    errorTable( registro_no_guardado );
                    break;
            }
        })
        .catch( error => {
            errorTable( registro_no_guardado );
        })
    }

    return (
        <ModalService title="Nuevo Turno" parentNode={nombreModulo}
            isOpen={ openAdd } onClose={ () => cerrarModal() } minWidth="60%" maxWidth="60%">
            <div className="row">
                <div className="col-12">
                    <FormTurnos
                        enviarTurnos={enviarTurnos}
                        error={error}
                    />
                </div>
            </div>
        </ModalService>
    );
}

export default ModalAddTurnos;